export default __webpack_public_path__ + "static/media/cm_band_de.b66bf204.jpg";